import { CatalogListingSchema } from "@redotech/redo-model/catalog/catalog-product-types";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

const PaginationInputSchema = z
  .object({
    pageSize: z.number().min(1).max(100).default(50),
    cursor: OpensearchPaginationCursorSchema.optional(),
  })
  .optional();

const SortInputSchema = z
  .object({ field: z.string(), order: z.enum(["asc", "desc"]) })
  .optional();

export const getCatalogProducts = {
  name: "getCatalogProducts" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    search: z.string().optional(),
    pagination: PaginationInputSchema,
    sort: SortInputSchema,
  }),
  output: z.object({
    listings: z.array(CatalogListingSchema),
    totalCount: z.number(),
    nextCursor: OpensearchPaginationCursorSchema.optional(),
    prevCursor: OpensearchPaginationCursorSchema.optional(),
  }),
};
